'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HeaderSearch = function () {
  function HeaderSearch(el) {
    (0, _classCallCheck3.default)(this, HeaderSearch);

    this.el = el;

    this.getElements();

    this.setupListeners();
  }

  (0, _createClass3.default)(HeaderSearch, [{
    key: 'getElements',
    value: function getElements() {
      this.els = {
        body: this.el.querySelector('[data-header-search-el="body"]'),
        input: this.el.querySelector('[data-header-search-el="input"]'),
        results: this.el.querySelector('[data-header-search-el="results"]'),
        default: this.el.querySelectorAll('[data-header-search-el="default"]')
      };
    }
  }, {
    key: 'setupListeners',
    value: function setupListeners() {
      this.handleInputChange = this.handleInputChange.bind(this);
      this.els.input.addEventListener('input', this.debounce(this.handleInputChange, 250));
    }
  }, {
    key: 'handleInputChange',
    value: function handleInputChange(e) {
      var searchTerm = e.target && e.target.value;
      if (searchTerm.length > 0) {
        this.updateResults(searchTerm);
      } else {
        this.reset();
      }
    }
  }, {
    key: 'updateResults',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(searchTerm) {
        var response, text, html, updatedBody;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return fetch('/search/suggest?q=' + searchTerm + '&resources[limit]=8&resources[limit_scope]=each&resources[options][fields]=title,product_type,variants.title,body&section_id=header-search');

              case 3:
                response = _context.sent;
                _context.next = 6;
                return response.text();

              case 6:
                text = _context.sent;
                html = document.createElement('div');

                html.innerHTML = text;

                updatedBody = html.querySelector('[data-header-search-el="body"]');

                if (this.els.body && updatedBody) {
                  this.els.body.innerHTML = updatedBody.innerHTML;
                  this.getElements();
                }
                _context.next = 16;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](0);

                console.error(_context.t0);

              case 16:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 13]]);
      }));

      function updateResults(_x) {
        return _ref.apply(this, arguments);
      }

      return updateResults;
    }()
  }, {
    key: 'reset',
    value: function reset() {
      this.els.results.setAttribute('aria-hidden', true);
      this.els.default.forEach(function (el) {
        el.setAttribute('aria-hidden', false);
      });
    }
  }, {
    key: 'debounce',
    value: function debounce(fn, wait) {
      var _this = this;

      var t = void 0;

      return function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        clearTimeout(t);
        t = setTimeout(function () {
          return fn.apply(_this, args);
        }, wait);
      };
    }
  }]);
  return HeaderSearch;
}();

exports.default = HeaderSearch;